import { render, staticRenderFns } from "./add_file.vue?vue&type=template&id=7c3c52a4&scoped=true"
import script from "./add_file.vue?vue&type=script&lang=js"
export * from "./add_file.vue?vue&type=script&lang=js"
import style0 from "./add_file.vue?vue&type=style&index=0&id=7c3c52a4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c3c52a4",
  null
  
)

export default component.exports